// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jdeVC","textarea":"styles_textarea__l-B8x"};